import { getAllSpecializationsReq } from "../../../redux/guest-slices/common.slice";
import { createExpertiseReq } from "../../../redux/specialist-slices/auth.slice";
import { Box, Button, Stack, Typography } from "@mui/material";
import InputField1 from "../../../components/ui/InputField1";
import SelectInput from "../../../components/ui/SelectInput";
import { validateNumber } from "../../../utils/velidations";
import FileInput from "../../../components/ui/FileInput";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { red } from "@mui/material/colors";

function Experties({ handleChange }) {
  const dispatch = useDispatch();
  const specialization = useRef("");
  const [errors, setErrors] = useState({});
  const [specials, setSpecials] = useState([]);
  const [defaultValue, setSefaultValue] = useState({});
  const { specialist } = useSelector((state) => state.specialistSlice);

  const files = useRef({
    certificate: specialist?.experties?.certificate || [],
  });

  // Handle add experties
  const handleSubmit = (e) => {
    e.preventDefault();
    const err = {};
    const form = new FormData(e.target);
    let formData = Object.fromEntries(form);
    formData.specializationId = specialization?.current?.value?._id;
    formData = {
      ...formData,
      ...files.current,
    };
    Object.keys(formData)?.forEach((field) => {
      const value = formData[field];
      if (Array.isArray(value)) {
        if (!value?.length) {
          err[field] = true;
        } else {
          delete err[field];
        }
      } else {
        if (value?.trim() === "" || !value) {
          err[field] = true;
        } else {
          delete err?.[field];
        }
      }
    });
    setErrors(err);
    if (!Object.keys(err)?.length) {
      dispatch(createExpertiseReq(formData))
        .unwrap()
        .then(() => {
          handleChange("background");
        })
        .catch(() => { });
    }
  };

  // Handle get all specializations
  const getAllSpecializations = (filters) => {
    dispatch(
      getAllSpecializationsReq({
        limit: filters?.limit || 100,
      })
    )
      .unwrap()
      .then((data) => {
        if (specialist?.experties?.specializationId) {
          setSefaultValue(
            data.find(
              ({ _id }) => _id === specialist?.experties.specializationId
            )
          );
        }
        setSpecials(data);
      })
      .catch(() => { });
  };

  useEffect(() => {
    getAllSpecializations();

    // eslint-disable-next-line
  }, [specialist?.verification?.currentStep]);

  return (
    <Box
      sx={{
        p: 3,
        borderRadius: "0 0 6px 6px",
        border: "1px solid #3498db",
        borderTop: "none",
      }}
    >
      <Typography
        mb={2}
        fontSize={36}
        component="h2"
        fontWeight="700"
        color="other.color1"
      >
        Showcase Your Expertise
      </Typography>
      <Typography mb={2} fontWeight="500" color="other.color2">
        Please provide your professional qualifications and experience. You can
        upload your certifications here
      </Typography>
      <Stack spacing={2} component="form" onSubmit={handleSubmit}>
        <Box>
          {specialist?.experties ? (
            <SelectInput
              options={[]}
              ref={specialization}
              value={defaultValue}
              renderValueKey="name"
              name="specializationI"
              select="Select type:-"
              varianttype="selectType1"
              label="Specialization *"
              selectLabel="Select type:-"
              disabled
            />
          ) : (
            <SelectInput
              options={specials}
              renderValueKey="name"
              ref={specialization}
              name="specializationId"
              select="Select type:-"
              varianttype="selectType1"
              label="Specialization *"
              selectLabel="Select type:-"
              defaultValue={defaultValue}
            />
          )}
          {errors?.specializationId && (
            <Typography mt={1} color={red["500"]}>
              Please enter specialization
            </Typography>
          )}
        </Box>
        <Box>
          <InputField1
            name="experience"
            onChangeFun={validateNumber}
            label="Total Experience (in Years) *"
            placeholder="Total Experience (in Years)"
            defaultValue={specialist?.experties?.experience || null}
          />
          {errors?.experience && (
            <Typography mt={1} color={red["500"]}>
              Please enter experience
            </Typography>
          )}
        </Box>
        <Box>
          <InputField1
            type="textarea"
            name="qualifications"
            placeholder="Qualifications"
            label="Certifications and Qualifications *"
            defaultValue={specialist?.experties?.qualifications || ""}
          />
          {errors?.qualifications && (
            <Typography mt={1} color={red["500"]}>
              Please enter qualifications
            </Typography>
          )}
        </Box>
        <FileInput
          files={files}
          errors={errors}
          name="certificate"
          label="Certification Documents *"
          errText="Please upload certificate documents"
          placeholderText="Upload Certification Documents"
          defaultValue={specialist?.experties?.certificate || []}
        />
        <Stack spacing={2} direction="row">
          <Button
            sx={{
              py: 1.2,
              minWidth: "110px",
              justifyContent: "center",
            }}
            type="submit"
            variant="contained"
          >
            Save as Draft
          </Button>
          <Button
            sx={{
              py: 1.2,
              minWidth: "110px",
              justifyContent: "center",
            }}
            type="submit"
            variant="contained"
          >
            Next
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}

export default Experties;
